<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" max-width="900">
			<v-card>
				<v-card-title class="text-h6" v-if="propAdd=='tambah'">Tambah Warehouse</v-card-title>
				<v-card-title class="text-h6" v-else>Edit Warehouse</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-col cols="12" sm="6" md="4" class="pb-0">
									<v-text-field outlined dense @focus="() => konfirmResponse.name=''" :error-messages="konfirmResponse.name"  v-model="paramAdd.name" label="Nama Warehouse"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" md="4" class="pb-0">
									<v-text-field @keypress="onlyNumber" @paste.prevent  outlined dense @focus="() => konfirmResponse.mobilephone=''" :error-messages="konfirmResponse.mobilephone" v-model="paramAdd.mobilephone" label="No. Handphone"></v-text-field>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-autocomplete outlined dense @focus="() => konfirmResponse.area_id=''" :error-messages="konfirmResponse.area_id" v-model="area_selected" :items="warehouseArea" item-text="area_name" return-object label="Area Warehouse" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-autocomplete outlined dense v-model="provins" @focus="() => konfirmResponse.province_id=''" :error-messages="konfirmResponse.province_id" :items="province" label="Provinsi" item-text="province" item-value="province_id" @change="getCity" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-autocomplete outlined dense v-model="kota" @focus="() => konfirmResponse.city_id=''" :error-messages="konfirmResponse.city_id" :items="city" label="Kota/Kabupaten" @change="getSubdistrict" :item-text="item => item.type + ' ' + item.city_name" item-value="city_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-autocomplete outlined dense @change="cekMaps" @focus="() => konfirmResponse.subdistrict_id=''" :error-messages="konfirmResponse.subdistrict_id" v-model="subdistrict_selected" :items="subdistrict" item-text="subdistrict_name" return-object label="Kecamatan" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
								<v-col cols="12" md="4" class="pb-0">
									<v-textarea outlined dense @change="cekMaps" @focus="() => konfirmResponse.address=''" :error-messages="konfirmResponse.address" v-model="paramAdd.address" label="Alamat" no-resize height="190"></v-textarea>
								</v-col>
								<v-col cols="12" md="8" class="pb-0">
									<v-card elevation="0" width="100%" height="190">
										<GmapMap :center="{ lat: location.lat, lng: location.lng}" :zoom="16" :options="mapOptions" map-type-id="roadmap" style="width: 100%; height: 100%" >
											<GmapMarker ref="myMarker" :position="{ lat: location.lat, lng: location.lng}" :draggable="true" @dragend="updateCoordinates" />
										</GmapMap>
									</v-card>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			page: 1,
			limit: "10",
			params: [],
			area_selected : '',
			provins : '',
			kota : '',
			subdistrict_selected : '',
			text : "",
			timeout: 2000,
			mapOptions:{
				zoomControl: false,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				disableDefaultUi: true
			},
			paramAdd: {
				name: '',
				mobilephone: '',
				province_id : '',
				province_name : '',
				city_id : '',
				city_name : '',
				subdistrict_id : '',
				subdistrict_name : '',
				address : '',
				latitude : '4.666131',
				longitude : '95.961004',
				area_id : '',
				area_name : '',
			},
		}
	},
	props: {
		value: Boolean,
		propAdd: String,
		edit: String,
		val: Object
	},
	computed: {
		...mapState('warehouseList', ['konfirmResponse', 'responSukses', 'warehouseArea', 'province', 'city', 'subdistrict']),
		...mapState('maps', ['location']),

		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {
		...mapActions('warehouseList', ['getWarehouse', 'getProvinceOption', 'add', 'update', 'getWarehouseAreaOption', 'getCityOption', 'getSubdistrictOption']),
		...mapMutations('warehouseList', ['konfirmasiSukses']),
		...mapActions('maps', ['getMaps', 'getGeolocation']),
		...mapMutations('maps', ['setLocation']),

		updateCoordinates(location){
			this.setLocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		cekMaps(){
			this.getMaps((this.paramAdd.address ? this.paramAdd.address + ', ' : '') + this.subdistrict_selected.subdistrict_name + ', ' + this.subdistrict_selected.city_name + ', ' + this.subdistrict_selected.province)
		},
		getCity() {
			this.kota = '';
			this.subdistrict_selected = '';
			this.getCityOption(this.provins)
		},
		getSubdistrict() {
			this.subdistrict_selected = '';
			this.getSubdistrictOption(this.kota)
		},
		batal() {
			this.dialog=false
			this.konfirmResponse.address=''
			this.konfirmResponse.area_id=''
			this.konfirmResponse.area_name=''
			this.konfirmResponse.city_id=''
			this.konfirmResponse.city_name=''
			this.konfirmResponse.mobilephone=''
			this.konfirmResponse.name=''
			this.konfirmResponse.province_id=''
			this.konfirmResponse.province_name=''
			this.konfirmResponse.subdistrict_id=''
			this.konfirmResponse.subdistrict_name=''
		},
		simpan() {
			this.paramAdd.latitude  = this.location.lat
			this.paramAdd.longitude = this.location.lng
			this.paramAdd.province_id = this.provins
			this.paramAdd.province_name = this.subdistrict_selected.province
			this.paramAdd.city_id = this.kota
			this.paramAdd.city_name = this.subdistrict_selected.city_name
			this.paramAdd.subdistrict_id = this.subdistrict_selected.subdistrict_id
			this.paramAdd.subdistrict_name = this.subdistrict_selected.subdistrict_name
			this.paramAdd.area_id = this.area_selected.area_id
			this.paramAdd.area_name = this.area_selected.area_name
			if(this.paramAdd) {
				if(this.propAdd == 'tambah') {
					this.add(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getWarehouse({limit:this.limit, page: 1, params:this.params})
							this.dialog= false
							this.reset()
						} else {
							this.dialog= true
						}
					})
				} else {
					this.update(this.paramAdd).then( () => {
						if(this.responSukses.code == 200) {
							this.getWarehouse({limit:this.limit, page: 1, params:this.params})
							this.dialog= false
							this.reset()
						} else {
							this.dialog= true
						}
					})
				}
			}
		},
		reset () {
			this.konfirmasiSukses('')
			this.paramAdd.name = ''
			this.paramAdd.mobilephone = ''
			this.paramAdd.address = ''
			this.paramAdd.province_id = ''
			this.paramAdd.province_name = ''
			this.paramAdd.city_id = ''
			this.paramAdd.city_name = ''
			this.paramAdd.subdistrict_id = ''
			this.paramAdd.subdistrict_name = ''
			this.paramAdd.area_id = ''
			this.paramAdd.area_name = ''
			this.provins = ''
			this.kota = ''
			this.area_selected = ''
			this.subdistrict_selected = ''
			this.konfirmResponse.address=''
			this.konfirmResponse.area_id=''
			this.konfirmResponse.area_name=''
			this.konfirmResponse.city_id=''
			this.konfirmResponse.city_name=''
			this.konfirmResponse.mobilephone=''
			this.konfirmResponse.name=''
			this.konfirmResponse.province_id=''
			this.konfirmResponse.province_name=''
			this.konfirmResponse.subdistrict_id=''
			this.konfirmResponse.subdistrict_name=''
		}
	},
	watch: {
		val () {
			this.paramAdd.id = this.val.warehouse_id
			this.paramAdd.name = this.val.warehouse_name
			this.paramAdd.mobilephone = this.val.warehouse_mobilephone
			this.provins = this.val.warehouse_province_id
			if(this.provins) {
				this.getCityOption(this.provins)
			}
			this.kota = this.val.warehouse_city_id
			if(this.kota) {
				this.getSubdistrictOption(this.kota)
			}
			this.subdistrict_selected = { "province_id": this.val.warehouse_province_id, "province": this.val.warehouse_province_name, "city_id": this.val.warehouse_city_id, "city_name": this.val.warehouse_city_name, "subdistrict_id": this.val.warehouse_subdistrict_id, "subdistrict_name": this.val.warehouse_subdistrict_name }
			this.paramAdd.address = this.val.warehouse_address
			this.area_selected = {"area_id": this.val.warehouse_area_id, "area_name": this.val.warehouse_area_name }
			this.paramAdd.latitude = this.val.warehouse_latitude
			this.paramAdd.longitude = this.val.warehouse_longitude
		}
	},
	created() {
		this.getProvinceOption()
		this.getWarehouseAreaOption()
	}
}
</script>
